/**
 * Generate a cryptographically secure webhook signing secret.
 * @returns {string}
 */
export function generateWebhookSigningSecret() {
  const bytes = new Uint8Array(32);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    throw new Error('Secure random generation is not available in this browser.');
  }
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `whsec_${hex}`;
}

/**
 * Mask a signing secret for compact display.
 * @param {string} secret
 * @returns {string}
 */
export function maskWebhookSigningSecret(secret) {
  if (!secret || typeof secret !== 'string') return 'whsec_***';
  if (secret.length <= 16) return 'whsec_***';
  return `${secret.slice(0, 12)}${'*'.repeat(8)}${secret.slice(-4)}`;
}
